<template>
  <form class="sm:flex flex-row gap-[8px]" @submit.prevent="submit">
    <input-default
      ref="addressInput"
      :error="v$.address.$error"
      :errorMessage="v$.address.$errors[0]?.$message"
      :model-value="address"
      placeholder="איפה אתם גרים?"
      @update:model-value="setAddress"
    >
      <template v-slot:right_icon>
        <span class="material-symbols-rounded text-grays-700 text-[20px]"
          >search</span
        >
      </template>
    </input-default>
    <button-primary type="submit" class="mt-2 sm:mt-0">
      {{ isLoading ? "loading" : "איפה יש תחנה קרובה" }}
    </button-primary>
  </form>
</template>

<script>
import useValidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { Loader } from "@googlemaps/js-api-loader";
import { mapMutations, mapState } from "vuex";
import ButtonPrimary from "@/components/Global/ButtonPrimary.vue";
import InputDefault from "@/components/Global/InputDefault.vue";

export default {
  name: "station-address-form",
  components: { InputDefault, ButtonPrimary },
  data() {
    return {
      v$: useValidate(),
      isLoading: false,
      googleInstance: null,
      lastPlace: null,
      lastPlaceAddress: null,
    };
  },
  props: {
    autoSubmitOnMount: {
      type: Boolean,
      default: false,
    },
  },
  validations() {
    return {
      address: { required },
    };
  },
  async mounted() {
    try {
      const apiKey = import.meta.env.VITE_API_KEY_GOOGLE_MAP;
      const loader = new Loader({
        apiKey,
        libraries: ["places"],
        region: "IL",
        language: "he",
      });
      const google = await loader.load();
      this.googleInstance = google;
      const autocomplete = new google.maps.places.Autocomplete(
        this.$refs.addressInput.$refs.input,
        {
          types: ["geocode"],
          componentRestrictions: { country: "il" },
          fields: ["formatted_address", "geometry", "place_id"],
        }
      );
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        if (place && place.formatted_address) {
          this.lastPlace = place;
          this.lastPlaceAddress = place.formatted_address;
          this.setAddress(place.formatted_address);
        }
      });
    } catch (error) {
      console.error("Error loading Google Maps API:", error);
    }

    // this.checkForStations();
    if (this.autoSubmitOnMount) {
      this.checkForStations();
    }
  },
  methods: {
    ...mapMutations({
      setAddress: "findStation/setAddress",
    }),
    async submit() {
      this.v$.$validate();
      if (!this.v$.address.$error) {
        this.isLoading = true;
        try {
          const google = this.googleInstance
            ? this.googleInstance
            : await new Loader({
                apiKey: import.meta.env.VITE_API_KEY_GOOGLE_MAP,
                libraries: ["places"],
                region: "IL",
                language: "he",
              }).load();

          const address = this.address;

          if (
            this.lastPlace &&
            this.lastPlace.geometry &&
            address === this.lastPlaceAddress
          ) {
            const latitude = this.lastPlace.geometry.location.lat();
            const longitude = this.lastPlace.geometry.location.lng();
            this.$emit("stations-found", { lng: longitude, lat: latitude });
            this.$emit("form-submitted");
            return;
          }

          const geocoder = new google.maps.Geocoder();
          geocoder.geocode(
            {
              address,
              region: "IL",
              componentRestrictions: { country: "IL" },
            },
            (results, status) => {
              if (status === "OK" && results?.length) {
                const latitude = results[0].geometry.location.lat();
                const longitude = results[0].geometry.location.lng();

                this.$emit("stations-found", { lng: longitude, lat: latitude });
                this.$emit("form-submitted");
              } else {
                const service = new google.maps.places.PlacesService(
                  document.createElement("div")
                );
                service.findPlaceFromQuery(
                  {
                    query: address,
                    fields: ["geometry", "formatted_address", "name"],
                    locationBias: {
                      center: { lat: 31.0461, lng: 34.8516 },
                      radius: 200000,
                    },
                  },
                  (placeResults, placeStatus) => {
                    if (
                      placeStatus ===
                        google.maps.places.PlacesServiceStatus.OK &&
                      placeResults?.length
                    ) {
                      const location = placeResults[0].geometry.location;
                      this.$emit("stations-found", {
                        lng: location.lng(),
                        lat: location.lat(),
                      });
                      this.$emit("form-submitted");
                    } else {
                      console.error(
                        "Geocode/Places search failed:",
                        status,
                        placeStatus
                      );
                    }
                  }
                );
              }
            }
          );
        } catch (error) {
          console.error("Error loading Google Maps API:", error);
        } finally {
          this.isLoading = false;
        }
      }
    },

    checkForStations() {
      if (!this.stations.length && this.address) {
        this.submit();
      }
    },
  },
  computed: {
    ...mapState({
      address: (state) => state.findStation.address,
      step: (state) => state.findStation.step,
      stations: (state) => state.findStation.stations,
    }),
  },
};
</script>

<style></style>
